import {
  APPROVE_REQUEST,
  APPROVE_REQUEST_FAILURE,
  APPROVE_REQUEST_SUCCESS,
  FETCH_REQUEST,
  FETCH_REQUESTS,
  FETCH_REQUESTS_FAILURE,
  FETCH_REQUESTS_SUCCESS,
  FETCH_REQUEST_SUCCESS,
  REJECT_REQUEST,
  REJECT_REQUEST_FAILURE,
  REJECT_REQUEST_SUCCESS,
  GET_REQUEST_CLIENTS,
  GET_REQUEST_CLIENTS_SUCCESS,
  GET_REQUEST_CLIENTS_FAILURE,
  FETCH_DOCUMENT_REQUEST,
  FETCH_DOCUMENT_SUCCESS,
  FETCH_DOCUMENT_FAILURE,
  INPROGRESS_STATUS_REQUEST,
  INPROGRESS_STATUS_SUCCESS,
  INPROGRESS_STATUS_FAILURE,
  UPDATE_REQUEST,
  UPDATE_REQUEST_SUCCESS,
  UPDATE_REQUEST_FAILURE,
  CHANGE_HISTORY,
  CHANGE_HISTORY_SUCCESS,
  SET_COMMENTS,
  SET_COMMENTS_SUCCESS,
  CREATE_ONEAPP_CLIENT_REQUEST,
  CREATE_ONEAPP_CLIENT_SUCCESS,
  CREATE_ONEAPP_CLIENT_FAILURE,
  AUTO_DEBT_LOAD_REQUEST,
  AUTO_DEBT_LOAD_SUCCESS,
  AUTO_DEBT_LOAD_FAILURE,
  GENERATE_CREDIT_CALCULATION_REPORT,
  CANCEL_REQUEST,
  CANCEL_REQUEST_SUCCESS,
  CREDIT_REGISTER_REQUEST,
  CREDIT_REGISTER_SUCCESS,
  CREDIT_REGISTER_FAILED,
  RESET_ERROR,
  WITHDRAW_CAR_DEPOSIT,
  WITHDRAW_CAR_DEPOSIT_REQUEST,
  FETCH_PAYMENT_SCHEDULE_REQUEST,
  FETCH_PAYMENT_SCHEDULE_SUCCESS,
  STATE_ERROR,
  FETCH_PAYMENT_SCHEDULE_FAILED, RESET_PAYMENT_SCHEDULE,
  APPROVE_ERROR,
} from "./actionTypes";

export const fetchRequests = (data) => ({
  type: FETCH_REQUESTS,
  payload: data,
});

export const fetchPaymentSchedule = (data) => ({
  type: FETCH_PAYMENT_SCHEDULE_REQUEST,
  payload: data,
});

export const setApproveError = (data) => ({
  type: APPROVE_ERROR,
  payload: data,
});

export const fetchPaymentScheduleSuccess = (data) => ({
  type: FETCH_PAYMENT_SCHEDULE_SUCCESS,
  payload: data,
});

export const fetchPaymentScheduleError = (data) => ({
  type: FETCH_PAYMENT_SCHEDULE_FAILED,
  payload: data,
});

export const fetchRequestsSuccess = (data) => ({
  type: FETCH_REQUESTS_SUCCESS,
  payload: data,
});

export const fetchChangeHistorySuccess = (data) => ({
  type: CHANGE_HISTORY_SUCCESS,
  payload: data,
});

export const fetchRequestsFailure = (error) => ({
  type: FETCH_REQUESTS_FAILURE,
  payload: error,
});

export const fetchRequest = (id) => ({
  type: FETCH_REQUEST,
  payload: { id },
});

export const fetchRequestSuccess = (data) => ({
  type: FETCH_REQUEST_SUCCESS,
  payload: data,
});

export const setCommentsSuccess = (data) => ({
  type: SET_COMMENTS_SUCCESS,
  payload: data,
});

export const rejectRequestFailure = (error) => ({
  type: REJECT_REQUEST_FAILURE,
  payload: error,
});

export const approveRequest = (data) => ({
  type: APPROVE_REQUEST,
  payload: data,
});

export const approveRequestSuccess = (data) => ({
  type: APPROVE_REQUEST_SUCCESS,
  payload: data,
});

export const resetPaymentSchedule = (data) => ({
  type: RESET_PAYMENT_SCHEDULE
});

export const approveRequestFailure = (error) => ({
  type: APPROVE_REQUEST_FAILURE,
  payload: error,
});

export const rejectRequest = (data) => ({
  type: REJECT_REQUEST,
  payload: data,
});

export const rejectRequestSuccess = (data) => ({
  type: REJECT_REQUEST_SUCCESS,
  payload: data,
});

export const cancelRequest = (data) => ({
  type: CANCEL_REQUEST,
  payload: data,
});

export const cancelRequestSuccess = (data) => ({
  type: CANCEL_REQUEST_SUCCESS,
  payload: data,
});

export const getRequestClients = (data) => ({
  type: GET_REQUEST_CLIENTS,
  payload: data,
});

export const getRequestClientsSuccess = (data) => ({
  type: GET_REQUEST_CLIENTS_SUCCESS,
  payload: data,
});

export const getRequestClientsFailure = (error) => ({
  type: GET_REQUEST_CLIENTS_FAILURE,
  payload: error,
});

export const fetchDocumentRequest = (data) => ({
  type: FETCH_DOCUMENT_REQUEST,
  payload: data,
});

export const fetchDocumentSuccess = (document) => ({
  type: FETCH_DOCUMENT_SUCCESS,
  payload: document,
});

export const fetchDocumentFailure = (error) => ({
  type: FETCH_DOCUMENT_FAILURE,
  payload: error,
});

export const inprogressRequest = (data) => ({
  type: INPROGRESS_STATUS_REQUEST,
  payload: data,
});

export const withdrawCarDepositRequest = (data) => ({
  type: WITHDRAW_CAR_DEPOSIT_REQUEST,
  payload: data,
});

export const inprogressRequestSuccess = (data) => ({
  type: INPROGRESS_STATUS_SUCCESS,
  payload: data,
});

export const inprogressRequestFailure = (error) => ({
  type: INPROGRESS_STATUS_FAILURE,
  payload: error,
});

export const updateRequest = (data) => ({
  type: UPDATE_REQUEST,
  payload: data,
});

export const fetchChangeHistory = (data) => ({
  type: CHANGE_HISTORY,
  payload: data,
});

export const setComments = (data) => ({
  type: SET_COMMENTS,
  payload: data,
});

export const updateRequestSuccess = (payload) => ({
  type: UPDATE_REQUEST_SUCCESS,
  payload
});

export const changeStateError = (payload) => ({
  type: STATE_ERROR,
  payload
});

export const updateRequestFailure = () => ({
  type: UPDATE_REQUEST_FAILURE
});

export const createOneAppClientRequest = (data) => ({
  type: CREATE_ONEAPP_CLIENT_REQUEST,
  payload: data,
});

export const creditRegisterRequest = (data) => ({
  type: CREDIT_REGISTER_REQUEST,
  payload: data,
});

export const createOneAppClientSuccess = () => ({
  type: CREATE_ONEAPP_CLIENT_SUCCESS
});

export const creditRegisterSuccess = (data) => ({
  type: CREDIT_REGISTER_SUCCESS,
  payload: data,
});

export const resetError = () => ({
  type: RESET_ERROR
});

export const creditRegisterFailed = (error) => {
  return {
    type: CREDIT_REGISTER_FAILED,
    payload: error,
  }
};

export const createOneAppClientFailure = (error) => ({
  type: CREATE_ONEAPP_CLIENT_FAILURE,
  payload: error,
});

export const autoDebtLoadRequest = (data) => ({
  type: AUTO_DEBT_LOAD_REQUEST,
  payload: data,
});

export const autoDebtLoadSuccess = () => ({
  type: AUTO_DEBT_LOAD_SUCCESS
});

export const autoDebtLoadFailure = (error) => ({
  type: AUTO_DEBT_LOAD_FAILURE,
  payload: error,
});

export const generateCreditCalculationReport = (data) => ({
  type: GENERATE_CREDIT_CALCULATION_REPORT,
  payload: data,
});